import based, { type CreateClient } from '@based/sdk/client'
import { useQuery as useQueryBase, type UseQuery } from '@based/sdk/react'
import type {
  schemaAnalytics,
  schemaDefault,
  schemaVotes,
} from './schema/based.schema.js'

import type f0 from './functions/analytics/accept-tracking/index.js'
import type f1 from './functions/analytics/events/index.js'
import type f2 from './functions/analytics/totals/index.js'
import type { publisher as f3Publisher, subscriber as f3Subscriber } from './functions/analytics/track/index.js'
import type f4 from './functions/audience/content/index.js'
import type f5 from './functions/audience/contestant/index.js'
import type f6 from './functions/audience/participating-voting-regions/index.js'
import type f7 from './functions/audience/payment/capture-job/index.js'
import type f8 from './functions/audience/payment/get-payment-config/index.js'
import type f9 from './functions/audience/payment/payment-error/index.js'
import type f10 from './functions/audience/payment/payment-rules/index.js'
import type f11 from './functions/audience/payment/payment-status/index.js'
import type f12 from './functions/audience/payment/payment-status-manager-job/index.js'
import type f13 from './functions/audience/payment/payment-stripe-pubkey/index.js'
import type f14 from './functions/audience/payment/process-payment/index.js'
import type f15 from './functions/audience/payment/request-payment/index.js'
import type f16 from './functions/audience/payment/stripe-webhook/index.js'
import type f17 from './functions/audience/payment/tempClearPayments/index.js'
import type f18 from './functions/audience/payment/tempPayments/index.js'
import type f19 from './functions/cms/active-users/index.js'
import type f20 from './functions/cms/auth/invite-verify/index.js'
import type f21 from './functions/cms/auth/logout/index.js'
import type f22 from './functions/cms/auth/passkeys-auth/index.js'
import type f23 from './functions/cms/auth/passkeys-auth-verify/index.js'
import type f24 from './functions/cms/auth/passkeys-register/index.js'
import type f25 from './functions/cms/auth/passkeys-register-verify/index.js'
import type f26 from './functions/cms/auth/send-otp/index.js'
import type f27 from './functions/cms/auth/verify-otp/index.js'
import type f28 from './functions/cms/db/ui-create/index.js'
import type f29 from './functions/cms/db/ui-delete/index.js'
import type f30 from './functions/cms/db/ui-query/index.js'
import type f31 from './functions/cms/db/ui-query-ast/index.js'
import type f32 from './functions/cms/db/ui-query-votes/index.js'
import type f33 from './functions/cms/db/ui-schema/index.js'
import type f34 from './functions/cms/db/ui-schema-votes/index.js'
import type f35 from './functions/cms/db/ui-total/index.js'
import type f36 from './functions/cms/db/ui-update/index.js'
import type f37 from './functions/cms/db/ui-update-votes/index.js'
import type f38 from './functions/cms/director/index.js'
import type f39 from './functions/cms/file-upload/index.js'
import type f40 from './functions/cms/preview/index.js'
import type f41 from './functions/cms/publish/index.js'
import type f42 from './functions/cms/publishable/index.js'
import type f43 from './functions/cms/published/index.js'
import type f44 from './functions/cms/results/results/index.js'
import type f45 from './functions/cms/results/results-cms/index.js'
import type f46 from './functions/cms/results/results-csv/index.js'
import type f47 from './functions/cms/results/results-csv-upload/index.js'
import type f48 from './functions/cms/results/results-frequency-upload/index.js'
import type f49 from './functions/cms/results/results-normalised/index.js'
import type f50 from './functions/cms/results/results-normalised-cms/index.js'
import type f51 from './functions/cms/results/results-settings/index.js'
import type f52 from './functions/cms/results/results-uk-cms/index.js'
import type f53 from './functions/cms/results/round-participating-countries/index.js'
import type f54 from './functions/cms/results/set-normalised/index.js'
import type f55 from './functions/cms/results/tempResults/index.js'
import type f56 from './functions/cms/results/tempResultsNormalized/index.js'
import type f57 from './functions/cms/round/index.js'
import type f58 from './functions/cms/sequences/index.js'
import type f59 from './functions/cms/translations/languages/index.js'
import type f60 from './functions/cms/translations/set-translated/index.js'
import type f61 from './functions/cms/translations/translation-progress/index.js'
import type f62 from './functions/cms/translations/translations-download/index.js'
import type f63 from './functions/cms/translations/translations-get-data/index.js'
import type f64 from './functions/cms/translations/translations-set-data/index.js'
import type f65 from './functions/cms/update-disposable-email-domains/index.js'
import type f66 from './functions/cms/user/get-member/index.js'
import type f67 from './functions/cms/user/get-my-passkeys/index.js'
import type f68 from './functions/cms/user/get-my-sessions/index.js'
import type f69 from './functions/cms/user/get-my-user/index.js'
import type f70 from './functions/cms/user/invite-member/index.js'
import type f71 from './functions/cms/user/logout-session/index.js'
import type f72 from './functions/cms/user/members/index.js'
import type f73 from './functions/cms/user/remove-member/index.js'
import type f74 from './functions/cms/user/remove-passkey/index.js'
import type f75 from './functions/cms/user/update-member/index.js'
import type f76 from './functions/cms/user/update-my-user/index.js'
import type f77 from './functions/cms/version/index.js'
import type f78 from './functions/create-payment-config/index.js'
import type f79 from './functions/fm-voting-data/index.js'
import type f80 from './functions/fm-voting-data-fetch/index.js'
import type f81 from './functions/loadtest/simple/index.js'
import type f82 from './functions/populate/index.js'

import {
  query as queryBase,
  type BasedQueryBuilder,
  type BasedQueryFunction as BQ,
  type BasedFunction as BF,
  type BasedChannelFunction as BCF,
  type BasedChannelPublishFunction as BCPF,
  type BasedJobFunction as BJF,
  type BasedFunctionClient as BFC,
} from '@based/sdk'

export type Endpoints = {
  'based:secret': BasedQueryFunction<string, string>
  'based:auth-email': BasedQueryFunction<{ type: 'passwordReset' | 'magicLink'; appName: string; email: string; callToAction: string; code: string } | { type: 'invite'; appName: string; email: string; callToAction: string } | { type: 'otp'; appName: string; email: string; callToAction?: string; code: string }, any>
  'based:connections': BasedQueryFunction<undefined, number>
  'accept-tracking': typeof f0
  'analytics-events': typeof f1
  'analytics-totals': typeof f2
  'track': { publisher: typeof f3Publisher, subscriber: typeof f3Subscriber }
  'content': typeof f4
  'contestant': typeof f5
  'participating-voting-regions': typeof f6
  'capture-job': typeof f7
  'get-payment-config': typeof f8
  'payment-error': typeof f9
  'payment-rules': typeof f10
  'payment-status': typeof f11
  'payment-status-manager-job': typeof f12
  'payment-stripe-pubkey': typeof f13
  'process-payment': typeof f14
  'request-payment': typeof f15
  'stripe-webhook': typeof f16
  'tempClearPayments': typeof f17
  'tempPayments': typeof f18
  'active-users': typeof f19
  'invite-verify': typeof f20
  'auth-logout': typeof f21
  'passkeys-auth': typeof f22
  'passkeys-auth-verify': typeof f23
  'passkeys-register': typeof f24
  'passkeys-register-verify': typeof f25
  'auth-send-otp': typeof f26
  'auth-verify-otp': typeof f27
  'ui-create': typeof f28
  'ui-delete': typeof f29
  'ui-query': typeof f30
  'ui-query-ast': typeof f31
  'ui-query-votes': typeof f32
  'ui-schema': typeof f33
  'ui-schema-votes': typeof f34
  'ui-total': typeof f35
  'ui-update': typeof f36
  'ui-update-votes': typeof f37
  'director': typeof f38
  'file-upload': typeof f39
  'preview': typeof f40
  'publish': typeof f41
  'publishable': typeof f42
  'published': typeof f43
  'results': typeof f44
  'results-cms': typeof f45
  'results-csv': typeof f46
  'results-csv-upload': typeof f47
  'results-frequency-upload': typeof f48
  'results-normalised': typeof f49
  'results-normalised-cms': typeof f50
  'results-settings': typeof f51
  'results-uk-cms': typeof f52
  'round-participating-countries': typeof f53
  'set-normalised': typeof f54
  'tempResults': typeof f55
  'tempResultsNormalised': typeof f56
  'round': typeof f57
  'sequences': typeof f58
  'languages': typeof f59
  'set-translated': typeof f60
  'translation-progress': typeof f61
  'translations-download': typeof f62
  'translations-get-data': typeof f63
  'translations-set-data': typeof f64
  'update-disposable-email-domains': typeof f65
  'get-member': typeof f66
  'get-my-passkeys': typeof f67
  'get-my-sessions': typeof f68
  'get-my-user': typeof f69
  'invite-member': typeof f70
  'logout-session': typeof f71
  'members': typeof f72
  'remove-member': typeof f73
  'remove-passkey': typeof f74
  'update-member': typeof f75
  'update-my-user': typeof f76
  'version': typeof f77
  'create-payment-config': typeof f78
  'fm-voting-data': typeof f79
  'fm-voting-data-fetch': typeof f80
  'simple': typeof f81
  'populate': typeof f82
}

type Schemas = {
  default: typeof schemaDefault
  analytics: typeof schemaAnalytics
  votes: typeof schemaVotes
}

export * from '@based/sdk'

export const createClient: CreateClient<Endpoints> = based
export const useQuery: UseQuery<Endpoints> = useQueryBase
export const queryAnalytics: BasedQueryBuilder<typeof schemaAnalytics> = queryBase
export const queryVotes: BasedQueryBuilder<typeof schemaVotes> = queryBase
export const query: BasedQueryBuilder<typeof schemaDefault> = queryBase

export type BasedQueryFunction<P = any, R = any> = BQ<P, R, Schemas, Endpoints>
export type BasedFunction<P = any, R = any> = BF<P, R, Schemas, Endpoints>
export type BasedChannelFunction<P = any, M = any> = BCF<P, M, Schemas, Endpoints>
export type BasedChannelPublishFunction<P = any, M = any> = BCPF<P, M, Schemas, Endpoints>
export type BasedJobFunction = BJF<Schemas, Endpoints>
export type BasedFunctionClient = BFC<Schemas, Endpoints>
